module.exports = __webpack_public_path__ + "media/images/icons/capacidad-21670e6f5fd4a219c037f51eb4f3a359.svg";